import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  productData: [],
  productId: null,
  productAttributes: {},
  attributeLov: {},
  productName: "",
  productAddOns: [],
  productOem: [],
  productTabs: [],
  buyNow: {
    activeTabs: "details",
  },
  attributeForm: {
    formState: {},
    modalState: {},
  },
};

const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    setProductData(state, action) {
      state.productData = action.payload;
    },
    changeActiveTabs: (state, action) => {
      state.buyNow.activeTabs = action.payload;
    },
    setProductAttributesData(state, action) {
      state.productAttributes = action.payload;
    },
    setProductName(state, action) {
      state.productName = action.payload;
    },
    setProductAddOnsData(state, action) {
      state.productAddOns = action.payload;
    },
    setProductOem(state, action) {
      state.productOem = action.payload;
    },
    setAttributeLov(state, action) {
      state.attributeLov = action.payload;
    },
    setProductId(state, action) {
      state.productId = action.payload;
    },
    setProductTabs(state, action) {
      state.productTabs = action.payload;
    },
    setAttributesFormForm(state, action) {
      state.attributeForm.formState = action.payload;
    },
    setModalForm(state, action) {
      state.attributeForm.modalState = action.payload;
    },
  },
});

export const {
  setProductData,
  changeActiveTabs,
  setProductAttributesData,
  setProductName,
  setProductAddOnsData,
  setProductOem,
  setAttributeLov,
  setProductId,
  setProductTabs,
  setAttributesFormForm,
  setModalForm
} = productSlice.actions;

export default productSlice.reducer;
